import { Service } from "../decorators/service.decorator";
import { NotificationFactory } from "../factories/NotificationFactory";
import { NotificationTypes } from "../types/NotificationTypes";

@Service()
export class NotificationService {

  _notificationFactory;

  constructor() {
    this._notificationFactory = new NotificationFactory();
  }

  success(title, text) {
    return this._notificationFactory.create(NotificationTypes.Success, title, text);
  }

  error(title, text) {
    return this._notificationFactory.create(NotificationTypes.Error, title, text);
  }
}
